import { translate as t } from '@thoughtspot/i18n';
import { Icon, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getSessionInfo, hasAdminPrivileges, isPrincipalImportExportEnabled, } from '@thoughtspot/session-service';
import _ from 'lodash';
import React from 'react';
import { MoreOptions } from '../more-options/more-options';
import styles from './roles.module.scss';
const DEFAULT_PAGINATION_BATCHSIZE = 20;
const getTranslations = (key, args) => t(`${key}`, args);
export const ON_CHANGE_DELAY = 300;
export const ROLE_NAME_MAX_LENGTH = 255;
export const ROLE_DESC_MAX_LENGTH = 124;
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["SAVE"] = "Save";
    TranslationsKeys["CANCEL"] = "Cancel";
    TranslationsKeys["DELETE"] = "modal.delete";
    TranslationsKeys["CONFIRM_DELETE"] = "roles.modal.delete.title";
    TranslationsKeys["CONFIRM_LABEL"] = "roles.modal.delete.label";
    TranslationsKeys["CONFIRM_DELETE_MSG"] = "roles.name.delete.confirmation";
    TranslationsKeys["CONFIRM_DELETE_MSG_MULTIPLE"] = "roles.multiple.delete.confirmation";
    TranslationsKeys["LOADING"] = "LOADING_MSG";
    TranslationsKeys["PAGE_TITLE"] = "roles.pageTitle";
    TranslationsKeys["COL_HEADER_ROLE_NAME"] = "roles.colHeader.roleName";
    TranslationsKeys["COL_HEADER_ROLE_DESC"] = "roles.colHeader.roleDesc";
    TranslationsKeys["COL_HEADER_PERMISSION"] = "roles.colHeader.permission";
    TranslationsKeys["COL_HEADER_GROUPS"] = "roles.colHeader.groups";
    TranslationsKeys["COL_HEADER_MORE_OPTIONS"] = "roles.colHeader.moreOptions";
    TranslationsKeys["ADD_ROLE_BUTTON_TITLE"] = "roles.addRole";
    TranslationsKeys["IMPORT_ROLE_BUTTON_TITLE"] = "roles.importRole";
    TranslationsKeys["EXPORT_ROLE_BUTTON_TITLE"] = "roles.exportRole";
    TranslationsKeys["MORE_OPTIONS_EDIT"] = "roles.moreOptions.edit";
    TranslationsKeys["MORE_OPTIONS_DELETE"] = "roles.moreOptions.delete";
    TranslationsKeys["MODAL_ADD_TITLE"] = "roles.addRole";
    TranslationsKeys["MODAL_EDIT_TITLE"] = "roles.modal.editTitle";
    TranslationsKeys["MODAL_FORM_NAME"] = "roles.modal.formFields.name";
    TranslationsKeys["MODAL_FORM_DESCRIPTION"] = "roles.modal.formFields.description";
    TranslationsKeys["MODAL_FORM_VALIDATION"] = "roles.modal.formFields.fieldName";
    TranslationsKeys["MODAL_FORM_NAME_MAX_LIMIT"] = "roles.modal.formFields.validName.maxLimit";
    TranslationsKeys["MODAL_FORM_FIELD_CHAR_LIMIT"] = "groups.modal.formFields.validField.charLimit";
    TranslationsKeys["MODAL_FORM_DESC_MAX_LIMIT"] = "roles.modal.formFields.validDescription.maxLimit";
    TranslationsKeys["ADD_ROLE_SUCCESS_MSG"] = "roles.add.success.msg";
    TranslationsKeys["UPDATE_ROLE_SUCCESS_MSG"] = "roles.update.success.msg";
    TranslationsKeys["DELETE_ROLE_SUCCESS_MSG"] = "roles.success.delete.msg";
    TranslationsKeys["ROLE_NAME_ALREADY_EXISTS"] = "roles.name.already.exists";
    TranslationsKeys["NO_ROLES_DEFINED"] = "no.roles.defined";
    TranslationsKeys["ADMIN_ERROR_GENERIC"] = "admin.error.generic";
    TranslationsKeys["ROLE_NAME_DESCRIPTION_LABEL"] = "roles.modal.formFields.nameDescriptionLabel2";
    TranslationsKeys["ROLE_DESCRIPTION_TITLE"] = "roles.modal.tab.roleDescriptionTitle";
    TranslationsKeys["None"] = "None";
    TranslationsKeys["BACK"] = "Back";
    TranslationsKeys["EXPORT"] = "EXPORT";
    TranslationsKeys["DELETE_ACTION_BAR"] = "DELETE";
    TranslationsKeys["SELECT_ALL_ITEMS"] = "smartCheckboxCollection.SELECT_ALL_ITEMS";
    TranslationsKeys["REVIEW_SELECTION"] = "roles.modal.reviewSelection";
    TranslationsKeys["UNIQUE_NAME_MESSAGE1"] = "roles.modal.formFields.uniqueNameMessage1";
    TranslationsKeys["UNIQUE_NAME_MESSAGE2"] = "roles.modal.formFields.uniqueNameMessage2";
    TranslationsKeys["REVIEW_MODAL_NO_PRIVILEGE_MSG1"] = "roles.reviewModal.noPrivilegeMessage1";
    TranslationsKeys["REVIEW_MODAL_NO_PRIVILEGE_MSG2"] = "roles.reviewModal.noPrivilegeMessage2";
    TranslationsKeys["ROLE_NAME_REQUIRED"] = "roles.modal.formFieldsRequired.fieldName";
    TranslationsKeys["ROLE_EXPORT_FAILURE"] = "roles.exportFailureMessage";
    TranslationsKeys["ROLE_EXPORT_SUCCESS"] = "roles.exportSuccessMessage";
    TranslationsKeys["SINGLE_ROLE_EXPORT_SUCCESS"] = "roles.singleExportSuccessMessage";
    TranslationsKeys["CLEAR"] = "Clear";
    TranslationsKeys["SELECT_ALL"] = "smartCheckboxCollection.SELECT_ALL_ITEMS";
    TranslationsKeys["PRIVILEGES"] = "adminSection.userManagement.privilegesLabel";
    TranslationsKeys["SHOW_SELECTED"] = "autoWorksheet.selectedItemsToggle.SHOW_SELECTED";
    TranslationsKeys["EXPORT_ERROR"] = "roles.Export.Error";
    TranslationsKeys["IMPORT_ROLE"] = "importTsl.importRole";
    TranslationsKeys["EXPORT_LIMIT_ERROR"] = "principal.export.error.maxLimit";
    TranslationsKeys["PREVIEW_THOUGHTSPOT_SPOTTER"] = "tennablePrivilegesLabels.PREVIEW_THOUGHTSPOT_SPOTTER";
})(TranslationsKeys || (TranslationsKeys = {}));
export var tableColumnHeaders;
(function (tableColumnHeaders) {
    tableColumnHeaders["ROLE_NAME"] = "roleName";
    tableColumnHeaders["ROLE_DESCRIPTION"] = "roleDesc";
    tableColumnHeaders["NUMBER_OF_PERMISSION"] = "numberOfPermission";
    tableColumnHeaders["NUMBER_OF_GROUPS_ASSIGNED"] = "numberOfGroupsAssigned";
    tableColumnHeaders["MORE_OPTION"] = "moreOption";
})(tableColumnHeaders || (tableColumnHeaders = {}));
export var ListActionType;
(function (ListActionType) {
    ListActionType["EDIT"] = "edit";
    ListActionType["DELETE"] = "delete";
    ListActionType["VIEW"] = "view";
    ListActionType["EXPORT"] = "export";
})(ListActionType || (ListActionType = {}));
export const MODE = {
    UPDATE: 'UPDATE',
    ADD: 'ADD',
    DELETE: 'DELETE',
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT',
};
export const roleListParams = {
    sortascending: true,
    batchsize: DEFAULT_PAGINATION_BATCHSIZE,
    offset: 0,
    pattern: '',
};
export const getExportUrl = (roleIds, exportAll = false) => {
    const roles = encodeURIComponent(JSON.stringify(roleIds));
    return `/callosum/v1/roles/export?roleIds=${roles}&exportAll=${exportAll}`;
};
export const generateMoreOption = (context, data) => {
    const editOption = {
        title: 'Group1',
        items: [
            {
                id: ListActionType.EDIT,
                label: t(TranslationsKeys.MORE_OPTIONS_EDIT),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.EDIT,
                        data,
                    });
                },
            },
        ],
    };
    const deleteOption = {
        title: 'Group2',
        items: [
            {
                id: ListActionType.DELETE,
                label: t(TranslationsKeys.MORE_OPTIONS_DELETE),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.DELETE,
                        data,
                    });
                },
            },
        ],
    };
    const exportOption = {
        title: 'Group3',
        items: [
            {
                id: ListActionType.EXPORT,
                label: t(TranslationsKeys.EXPORT),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.EXPORT,
                        data,
                    });
                },
            },
        ],
    };
    return isPrincipalImportExportEnabled()
        ? [editOption, deleteOption, exportOption]
        : [editOption, deleteOption];
};
export const RoleName = ({ data, context }) => {
    const name = data[tableColumnHeaders.ROLE_NAME].text;
    const elementProps = {
        variant: 'p',
        overrideTag: 'div',
        children: name,
        ellipsis: { rows: 1 },
        tooltipConfig: {
            showTooltipOnlyOnEllipsis: true,
            dataTooltipAlign: 'center',
            dataTooltipContent: name,
        },
    };
    if (!data.readOnly) {
        elementProps.color = Colors.accent;
        elementProps.className = styles.roleName;
        elementProps.onClick = () => {
            context.onRowAction({
                action: ListActionType.VIEW,
                data,
            });
        };
    }
    return (React.createElement("div", { className: styles.roleNameWrapper },
        React.createElement(Vertical, null,
            React.createElement(Typography, { ...elementProps }))));
};
export const getColumnDefinitions = () => {
    return [
        {
            cellRenderer: (params) => {
                return React.createElement(RoleName, { ...params });
            },
            headerName: t(TranslationsKeys.COL_HEADER_ROLE_NAME),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.ROLE_NAME,
            sortable: true,
            flex: 2,
            suppressMovable: true,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationsKeys.COL_HEADER_ROLE_DESC),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.ROLE_DESCRIPTION,
            sortable: false,
            flex: 2,
            suppressMovable: true,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationsKeys.COL_HEADER_PERMISSION),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.NUMBER_OF_PERMISSION,
            sortable: false,
            flex: 1,
            suppressMovable: true,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationsKeys.COL_HEADER_GROUPS),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.NUMBER_OF_GROUPS_ASSIGNED,
            sortable: false,
            flex: 1,
            suppressMovable: true,
        },
        {
            cellRenderer: (params) => {
                const { context, data } = params;
                if (data.readOnly) {
                    return null;
                }
                return (React.createElement(MoreOptions, { menuId: 1, menuLabel: t(TranslationsKeys.COL_HEADER_MORE_OPTIONS), menuItemGroups: generateMoreOption(context, data), isDisabled: data.isChecked }));
            },
            colId: tableColumnHeaders.MORE_OPTION,
            headerName: '',
            headerClass: [styles.headerStyle, styles.moreHeaderStyle],
            sortable: false,
            width: 50,
            suppressMovable: true,
        },
    ];
};
export const getPrismErrorMessage = (apolloError) => {
    const networkError = apolloError.networkError;
    const errors = networkError?.result?.errors || [];
    const errorResponse = errors[0]?.extensions?.exception?.upstreamResponse;
    const errorCode = errorResponse?.status;
    const errorMessage = errorResponse?.data?.failedReason ||
        errors[0]?.message ||
        t(TranslationsKeys.ADMIN_ERROR_GENERIC);
    return [errorCode, errorMessage];
};
export const getToastMessage = (scenario, rolesCount = 0) => {
    if (scenario === MODE.ADD) {
        return t(TranslationsKeys.ADD_ROLE_SUCCESS_MSG);
    }
    if (scenario === MODE.UPDATE) {
        return t(TranslationsKeys.UPDATE_ROLE_SUCCESS_MSG);
    }
    if (scenario === MODE.DELETE) {
        return t(TranslationsKeys.DELETE_ROLE_SUCCESS_MSG);
    }
    if (scenario === MODE.EXPORT) {
        return t(rolesCount > 1
            ? TranslationsKeys.ROLE_EXPORT_SUCCESS
            : TranslationsKeys.SINGLE_ROLE_EXPORT_SUCCESS, {
            roles_count: rolesCount,
        });
    }
    return null;
};
export const getFlattenPrivilegesList = (privilegesList) => {
    return (privilegesList?.reduce((acc, item) => {
        if (!_.isEmpty(item.privileges)) {
            acc.push(item.groupName);
            acc.push(...item.privileges);
        }
        return acc;
    }, []) || []);
};
export const hasCreateEditInputError = (hasInputError, name, description) => {
    let isNameRequired = false;
    let isNameLong = false;
    let isDescriptionLong = false;
    if (_.isEmpty(name)) {
        isNameRequired = true;
    }
    if (name.length > ROLE_NAME_MAX_LENGTH) {
        isNameLong = true;
    }
    if (description.length > ROLE_DESC_MAX_LENGTH) {
        isDescriptionLong = true;
    }
    return {
        ...hasInputError,
        isNameRequired,
        isNameLong,
        isDescriptionLong,
    };
};
export const getInputLabel = (hasError, translate) => {
    if (hasError.isNameRequired) {
        return translate(TranslationsKeys.ROLE_NAME_REQUIRED);
    }
    if (hasError.isNameLong) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.MODAL_FORM_NAME),
            char_limit: ROLE_NAME_MAX_LENGTH,
        });
    }
    if (hasError.isDescriptionLong) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.MODAL_FORM_DESCRIPTION),
            char_limit: ROLE_DESC_MAX_LENGTH,
        });
    }
    return translate(TranslationsKeys.ROLE_NAME_DESCRIPTION_LABEL);
};
export const getInputLabelColor = (hasError) => {
    const { isNameRequired, isNameLong, isDescriptionLong } = hasError;
    return isNameRequired || isNameLong || isDescriptionLong;
};
export const renderItemForReviewPrivilege = (privilege, containerCss, iconId, iconCss) => (React.createElement(Horizontal, { key: privilege, className: containerCss },
    React.createElement(Icon, { id: iconId, size: IconSize.SMALL, className: iconCss || null }),
    React.createElement(Typography, { variant: "p", overrideTag: "div" }, getTranslations(`tennablePrivilegesLabels.${privilege}`))));
export const renderFormFieldValue = (fieldValue, isUpdated, containerCss, value) => (React.createElement(Vertical, null,
    React.createElement(Typography, { variant: "p-bold", overrideTag: "div" },
        fieldValue,
        ":"),
    isUpdated ? (React.createElement(Horizontal, { className: containerCss },
        React.createElement(Icon, { id: IconID.CHECKMARK, size: IconSize.SMALL }),
        React.createElement(Typography, { variant: "p", overrideTag: "div" }, value))) : (React.createElement(Typography, { variant: "p", overrideTag: "div" }, value))));
export const refreshCells = (gridRef, rowIds, colId) => {
    const rowNodes = rowIds.map((id) => gridRef.current.getRowNode(id));
    gridRef.current.refreshCells({
        rowNodes: [...rowNodes],
        columns: [colId],
    });
};
export const isVisible = (privilege) => {
    return (getSessionInfo().privileges.some(permission => permission === privilege) || hasAdminPrivileges());
};
//# sourceMappingURL=util.js.map